import type React from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

interface Props {
  className: string
}

export const Separator: React.FC<Props> = ({ className }) => {
  return (
    <div className={clsJoin(css.separator, className)}>
      <div className={css.line} />
    </div>
  )
}
